import { render, staticRenderFns } from "./LimitationPublishPage.vue?vue&type=template&id=76698399&scoped=true&"
import script from "./LimitationPublishPage.vue?vue&type=script&lang=js&"
export * from "./LimitationPublishPage.vue?vue&type=script&lang=js&"
import style0 from "./LimitationPublishPage.vue?vue&type=style&index=0&id=76698399&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76698399",
  null
  
)

export default component.exports